import {
  FETCH_SCHEDULES_DATES,
  MY_AGENDA_LIST,
  CURRENT_DATE_AGENDA,
  FETCH_MEETINGS
} from '../actions';

export const scheduleDatesReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_SCHEDULES_DATES:
      return action.payload;
    default:
      return state;
  }
};

export const myAgenda = (state = {}, action) => {
  switch (action.type) {
    case MY_AGENDA_LIST:
      return action.payload;
    default:
      return state;
  }
};

export const selectedDateAgenda = (state = {}, action) => {
  switch (action.type) {
    case CURRENT_DATE_AGENDA:
      return action.payload;
    default:
      return state;
  }
};
